module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/logo-coj-zh-hant-256611ae29ca02b8bf087cef3ff22df4.png";